import {post,get,jsonp} from './../js/common';
import qs from 'qs';
import {config} from './../config/config';
/**********客户端请求***********/
export async function sendSms(params){
    return post(config.baseUrl+'/api/user/login/mobile/sendSms',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function loginWithSms(params){
    return post(config.baseUrl+'/api/user/login/mobile/loginWithSms',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function loginWithPhonePwd(params){
    return post(config.baseUrl+'/api/user/login/mobile/loginWithPwd',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function loginWithEmailPwd(params){
    return post(config.baseUrl+'/api/user/login/emailAndUserName/loginWithPwd',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function sendVerificationMail(params){
    return get(config.baseUrl+'/api/user/account/resetPwd/sendVerificationMail',params);
}
export async function verifMailCode(params){
    return get(config.baseUrl+'/api/user/account/resetPwd/verifMailCode',params);
}
export async function verifSmsCode(params){
    return get(config.baseUrl+'/api/user/account/resetPwd/verifSmsCode',params);
}
export async function resetSendSms(params){
    return post(config.baseUrl+'/api/user/account/resetPwd/sendSms',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function bindMobile(params){
    return get(config.baseUrl+'/api/user/account/bindMobile/verifSmsCode',params);
}
export const QQLogin=config.baseUrl+'/api/user/login/render/qq';
export const weixinLogin=config.baseUrl+'/api/user/login/render/wechat_open';
export const weiboLogin=config.baseUrl+'/api/user/login/render/weibo';
export async function getSites(params){
    return post(config.baseUrl+'/sso/getCookie',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function getPersonalInfo(params){
    return get(config.baseUrl+'/api/user/account/getPersonalInfo',params);
}
export async function jsonpSso(url){
    return jsonp(url);
}
export async function getQCaptEncryptAppid(params){
    return post(config.baseUrl+'/common/getQCaptEncryptAppid',qs.stringify(params),{headers:{'Content-Type': 'application/x-www-form-urlencoded'}});
}
export async function changePwd(params){
    return get(config.baseUrl+'/api/user/account/changePwd',params);
}